import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'lib-show-more',
  templateUrl: './show-more.component.html',
  styleUrls: ['./show-more.component.scss'],
  standalone: false,
})
export class ShowMoreComponent {
  @Input() items: any[] = [];
  @Input() label: string = 'value'; // which field of the item to display
  @Input() isOpen = false;
  showDropdown = false;

  @Output() toggle = new EventEmitter<void>();

  @HostListener('click', ['$event'])
  onSelfClick(event: MouseEvent) {
    event.stopPropagation();
  }

  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }

  onToggleClick() {
    this.toggle.emit();
  }
}
